import type { Role } from '@propmgt/shared';

/**
 * The SPA home shell for each role (0.25.0). An explicit map — never "tenant ? portal : admin",
 * which would drop a contractor (or any future role) into the admin shell. Mirrors the API, where
 * every route names the roles it admits.
 */
export function homeFor(role: Role | string): '/portal' | '/admin' | '/contractor' | '/login' {
  switch (role) {
    case 'tenant':
      return '/portal';
    case 'owner':
    case 'staff':
      return '/admin';
    case 'contractor':
      return '/contractor';
    default:
      return '/login';
  }
}

/** Which roles each SPA shell admits. */
export const SHELL_ROLES: Record<'tenant' | 'admin' | 'contractor', readonly Role[]> = {
  tenant: ['tenant'],
  admin: ['owner', 'staff'],
  contractor: ['contractor'],
};
